import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth.service';
import { catchError, interval, of, switchMap, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {

  private heartbeatInterval = 60 * 1_000; // 60 seconds
  private healthCheckFailed = false;

  constructor(
    private loggingService: LoggingService,
    private authService: AuthService,
  ) {
    this.startHeartbeat();
  }

  startHeartbeat() {
    interval(this.heartbeatInterval).pipe(
      switchMap(() =>
        this.authService.getV2CloudFunction(environment.cloudFunctions.healthCheckEndpoint, {}).pipe(
          tap(response => { this.healthCheckFailed = Boolean(response?.offline); }),
          catchError(error => {
            this.healthCheckFailed = true;
            this.loggingService.logError('Health check failed', error);
            return of(null);
          })
        )
      )
    ).subscribe();
  }

  public getHealthCheckFailedStatus(): boolean {
    return this.healthCheckFailed;
  }
}
